import { IButtons } from '@features/General'
import { rootActions } from '@store/slices'
import store from '@store/store'

export const listButtons = (i18n): IButtons[] => [
    {
        key: 'AddContact',
        type: 'primary-solid',
        hasPadding: true,
        abilityService: 'companies',
        title: i18n?.TradeHub?.AddContact || 'Add Contact',
        onClick: () =>
            store.dispatch(
                rootActions.ui.companyProfile.setEmployeesEditorModal({ isOpen: true, data: {}, view: false })
            )
    }
]
